import React, { Component } from 'react'
import { Row, Col, Modal, Form, Button } from 'react-bootstrap'

class DeleteDraftModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isToggle: true
        };
    }


    render() {
        console.log("this.",this.props.deletePaper)


        return (
            <Modal {...this.props}
                size="md" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg"> Delete saved paper</Modal.Title>

                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row>
                    <Col  sm={12} className="text-center">
                        {this.props.spinnerStatus == "1" ? (<div class="spinner-border text-primary"></div>) : ("")}
                    </Col>
                    <Col sm={12} class="text-center" style={{ display: this.state.isToggle ? 'block' : 'none' }}>
                        <h6 className="text-center mb-4">Are you sure you want to Delete</h6>
                        <div className="d-flex flex-row justify-content-center">
                            <Button className="btn btn-success text-uppercase px-lg-5 ml-1" onClick={this.props.handleDelete}>yes</Button>
                            <Button className="btn btn-success text-uppercase px-lg-5 ml-1" onClick={this.props.closePopup}>No</Button>
                        </div>
                    </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

export default DeleteDraftModal
